module.exports = __webpack_public_path__ + "img/18.d424f575.svg";